// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3izTA","footer":"styles_footer__F4vdw","passCodeTooltip":"styles_passCodeTooltip__1kAdc"};